import { useEffect } from 'react';

/**
 * Lightweight SEO hook: updates document.title and meta description per-route
 * without adding a library dependency (react-helmet).
 */
export default function useSEO({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement('meta');
        m.setAttribute('name', 'description');
        document.head.appendChild(m);
      }
      m.setAttribute('content', description);
    }
  }, [title, description]);
}
